'use strict';

/**
 *  Load modules
 */
import burgerMenu from './modules/burgerMenu.js';
import simplebar from './modules/simplebar.js';
import openClose from './modules/openClose.js';
import swiper from './modules/swiper.js';
//import customSelect from './modules/customSelect.js';
import video from './modules/video.js';
import autocomplete from './modules/autocomplete.js';
import clickboxes from './modules/clickboxes.js';
import '../scss/app.scss';
$(document).ready(function () {
  jQuery('.header__search-opener').on('click', function (e) {
    e.preventDefault();
    if (jQuery('body').hasClass('nav-active')) {
      jQuery('body').removeClass('nav-active');
    }
  });
  jQuery('.account__col a[href*="#signup"]').on('click', function (e) {
    e.preventDefault();
    jQuery('#account-form-signup').slideDown('slow');
  });
  if (jQuery('.equip__filter').length) {
    var hiddenClass = 'hidden';
    var activeClass = 'filter-active';
    var itemBlocks = jQuery('.equip__product-item');
    var itemHeadings = jQuery('.equip__product > h3');
    jQuery('.equip__filter input:checkbox').on('change', function () {
      itemBlocks.addClass(hiddenClass);
      itemHeadings.addClass(hiddenClass);
      jQuery('.equip__filter input:checkbox').each(function () {
        if (jQuery(this).is(':checked')) {
          itemBlocks.filter('.' + jQuery(this).attr('id')).removeClass(hiddenClass).addClass(activeClass);
          itemHeadings.filter('.' + jQuery(this).attr('id')).removeClass(hiddenClass);
        } else {
          itemBlocks.filter('.' + jQuery(this).attr('id')).removeClass(activeClass).addClass(hiddenClass);
        }
        if (!jQuery('.equip__filter input:checkbox').is(':checked')) {
          itemBlocks.removeClass(hiddenClass);
          itemHeadings.removeClass(hiddenClass).removeClass(activeClass);
        }
      });
    });
    jQuery('.filter-clear').on('click', function (e) {
      e.preventDefault();
      itemBlocks.removeClass(hiddenClass).removeClass(activeClass);
      itemHeadings.removeClass(hiddenClass).removeClass(activeClass);
      jQuery('.equip__filter input:checkbox').prop('checked', false);
    });
  }
});